export default "/images/vendor/flag-icons/flags/1x1/io.svg?27431f534aa480e1d00302922a768a26";